import type { SVGProps } from 'react';

const SvgLightBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.9492 2.95117V3.95117'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.9492 20.9512V19.9512'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.9492 11.9512H19.9492'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.94922 11.9512H3.94922'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.6055 5.29395L17.8984 6.00105'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5.29289 18.6085L6 17.9014'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.6055 18.6085L17.8984 17.9014'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5.29297 5.29395L6.00008 6.00105'
      stroke='currentColor'
      strokeWidth={2.1}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgLightBd;
